import React from 'react';

const RefundPolicyPage: React.FC = () => {
  return (
    <div className="legal-page container py-5">
      <h1 className="mb-4">退款政策</h1>

      <p className="text-muted mb-4">
        为了与支付服务商（包括 Paddle 在内）的标准保持一致，并保障您的合法权益，GitHub AI 平台对退款规则作如下说明。
      </p>

      <h3>一、适用范围</h3>
      <p>
        本退款政策适用于您通过 GitHub AI 平台及其接入的支付服务商购买的会员服务或其他虚拟付费功能（例如体验会员、增值服务等）。
      </p>

      <h3>二、退款窗口（适用于通过 Paddle 支付的订单）</h3>
      <p>
        对于通过 Paddle 支付完成的订单，我们提供自支付完成之日起 <strong>14 天内</strong> 的无条件退款窗口。
        在此期间，您可以通过 Paddle 或本平台指定渠道提出退款申请，无需说明理由。超过 14 天，则不再提供退款（法律法规另有规定的除外）。
      </p>

      <h3>三、其他支付方式</h3>
      <p>
        对于暂未接入 Paddle、通过人工方式完成的体验开通或测试性付费，我们将参考上述 14 天退款窗口进行处理，具体以实际约定为准。
        后续正式接入 Paddle 后，所有在线支付将优先通过 Paddle 完成，并严格遵循其退款规则。
      </p>

      <h3>四、申请方式与处理时间</h3>
      <ul>
        <li>
          您可以通过 Paddle 提供的退款入口发起申请，或通过本网站的反馈入口、联系方式（如邮箱、微信等）联系我们协助处理。
        </li>
        <li>
          在收到您的退款请求及必要信息（例如订单号、支付凭证）后，我们通常会在 <strong>3–7 个工作日</strong> 内完成审核并配合支付服务商完成退款。
        </li>
        <li>
          实际到账时间将取决于支付服务商及银行处理速度，一般不超过若干工作日。
        </li>
      </ul>

      <h3>五、退款后的服务处理</h3>
      <p>
        当您的退款申请被批准并实际完成退款后，与该笔订单对应的会员或付费权益将同步终止或调整。您在此之前已经享受的服务（包括已生成的 AI 解读结果、
        历史分析报告等），原则上将不再另行折算或补偿。
      </p>

      <h3>六、与支付服务商政策的一致性</h3>
      <p>
        通过 Paddle 等第三方支付服务商完成的支付及退款，最终将以该服务商的退款规则为准。本页面所述条款旨在帮助您理解整体流程，并不会减少您依据 Paddle
        政策所享有的任何权利。
      </p>

      <h3>七、联系我们</h3>
      <p>
        如您对本退款政策有任何疑问或需申请退款协助，请通过网站底部展示的联系方式与我们取得联系，我们会尽快予以回复和处理。
      </p>
    </div>
  );
};

export default RefundPolicyPage;

